export function formatDate(dateStr: string): string {
	const date = new Date(dateStr);
	return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
